import { callApi } from '../apiCaller';
import { toastError } from '../utils';

// action name
export const SET_SUBSCRIBER_PRODUCT_EVENTS = 'setSubscriberProductEvents';

// Api
const API_GUEST_SUBSCRIBER_PRODUCT_EVENTS = 'products/:productId/events';
const API_GUEST_SUBSCRIBER_PRODUCT_EVENT = 'products/events/:eventId';

export const setSubscriberProductEvents = (products) => {
     return {
          type: SET_SUBSCRIBER_PRODUCT_EVENTS,
          payload: products,
     };
};

export const fetchSubscriberProductEventsRequest = (id, setFunction) => (dispatch) => {
     callApi(API_GUEST_SUBSCRIBER_PRODUCT_EVENTS.replace(':productId', id), 'GET')
          .then((response) => {
               if (response.status === 200) {
                    if (typeof setFunction !== 'undefined') {
                         setFunction(response.data);
                    }
                    dispatch(setSubscriberProductEvents(response.data));
               } else {
                    toastError(response);
               }
          })
          .finally();
};

export const fetchSubscriberLimitProductEventsRequest =
     ({ id, setFunction, userId, organizationId, setIsLoading }) =>
     (dispatch) => {
          let urlApi = API_GUEST_SUBSCRIBER_PRODUCT_EVENTS.replace(':productId', id);

          if (userId) {
               urlApi += `?userId=${userId}`;
          } else if (organizationId) {
               urlApi += `?organizationId=${organizationId}`;
          }
          if (typeof setIsLoading === 'function') {
               setIsLoading(true);
          }

          callApi(urlApi, 'GET')
               .then((response) => {
                    if (response.status === 200) {
                         if (typeof setFunction !== 'undefined') {
                              setFunction(response.data);
                         }
                         dispatch(setSubscriberProductEvents(response.data));
                    } else {
                         toastError(response);
                    }
               })
               .finally(() => {
                    if (typeof setIsLoading === 'function') {
                         setIsLoading(false);
                    }
               });
     };

export const fetchSubscriberProductEventRequest = (eventId, nextDispatch) => (dispatch) => {
     const { setEventDetail, setIsLoading } = nextDispatch;

     if (setIsLoading) {
          setIsLoading(true);
     }

     callApi(API_GUEST_SUBSCRIBER_PRODUCT_EVENT.replace(':eventId', eventId), 'GET').then((response) => {
          if (response.status === 200) {
               if (setEventDetail) {
                    setEventDetail(response.data || null);
               }
          } else {
               toastError(response);
          }
          if (setIsLoading) {
               setIsLoading(false);
          }
     });
};
